// import images
import signUpImg from "../assets/image/forSignUp.svg";
import SignUpFrom from "./SignUpFrom";
// import out css
import Classes from "./style/signUp.module.css";

export default function SignUp(){
    return(
        <>
            <div className={Classes.sing_main}>
  <div className="card text-black medium"  style={{width:"100vw"}}>
    <div className="card-body p-md-5">
      <div className="row justify-content-center">
        <div className="col-md-10 col-lg-6 col-xl-5 order-2 order-lg-1">
          <h2 className="text-center h1 fw-bold mb-5 mx-1 mx-md-4 mt-4">Sign up</h2>
          
          <SignUpFrom/>
        </div>
        <div
          className="col-md-10 col-lg-6 col-xl-7 d-flex align-items-center order-1 order-lg-2"
        >
          <img
            src={signUpImg}
            className="img-fluid img"
            alt="Sample Img"
          />
        </div>
      </div>
    </div>
  </div>
</div>
        </>
    );
}